import { aboutSections } from './aboutOurClubSections';
import { joiningSections } from './thinkingOfJoiningSections';

export interface NavSubItem {
    label: string;
    page: string;
    sectionId?: string;
}

export interface NavItem {
    label: string;
    page?: string;       // top-level navigation target (optional for dropdown-only items)
    isContact?: boolean; // special case: scroll to #contact on home page
    subItems?: NavSubItem[];
}

export const navItems: NavItem[] = [
    {
        label: 'Home',
        page: 'home',
    },
    {
        label: 'About Our Club',
        page: 'about-our-club',
        subItems: [
            ...aboutSections.map(s => ({ label: s.title, page: 'about-our-club', sectionId: s.id })),
            { label: 'Instructors', page: 'instructors' },
            { label: 'What Our Community Says', page: 'home', sectionId: 'reviews' },
        ],
    },
    {
        label: 'Thinking of Joining?',
        page: 'thinking-of-joining',
        subItems: joiningSections.flatMap(s => {
            const item: NavSubItem = { label: s.title, page: 'thinking-of-joining', sectionId: s.id };
            if (s.id === 'trial-classes') {
                return [item, { label: 'Joining Form', page: 'trial-class' }];
            }
            return [item];
        }),
    },
    {
        label: 'Existing Students',
        subItems: [
            { label: 'Upcoming Events', page: 'upcoming-events' },
            { label: 'Grading Journey', page: 'grading-journey' },
            { label: 'Theory', page: 'theory' },
            { label: 'Competitions', page: 'competitions' },
            { label: 'Safeguarding', page: 'safeguarding' },
        ],
    },
    {
        label: 'Gallery',
        page: 'gallery',
    },
    {
        label: 'Contact Us',
        isContact: true,
    },
];
